import React, { useState, useEffect } from "react";
import { FiMessageSquare, FiPlus } from "react-icons/fi";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useComponentTranslation } from "@/services/i18n";

import ContactSelectionModal from "./ContactSelectionModal";

import api from "@/services/api";
import useStore from "@/services/store";
import Loader from "@/components/loader";
import i18n from "@/locales";

const translations = {
  en: {
    new_conversation: "New Conversation",
    no_conversations: "No conversations yet",
  },
  fr: {
    new_conversation: "Nouvelle conversation",
    no_conversations: "Aucune conversation pour le moment",
  },
};

const ChatList = ({ basePath = "/chat" }) => {
  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useComponentTranslation(translations);
  const { organization } = useStore();

  useEffect(() => {
    fetchConversations();
  }, []);

  const fetchConversations = async () => {
    try {
      setLoading(true);
      const { ok, code, data } = await api.post("/conversation/search", { organization_id: organization?._id });
      if (!ok) throw new Error(code);
      setConversations(data);
      if (!id && data.length > 0) navigate(`${basePath}/${data[0]._id}`);
    } catch (e) {
      console.error("Error fetching conversations:", e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col h-full bg-white border border-gray-200 rounded-xl overflow-hidden">
      {/* <div className="p-4 border-b border-gray-200">
        <button onClick={() => setIsModalOpen(true)} className="btn btn-primary w-full">
          <FiPlus className="w-4 h-4" />
          {t("new_conversation")}
        </button>
      </div> */}

      <div className="flex-1 overflow-y-auto">
        {loading ? (
          <div className="flex items-center justify-center h-full">
            <Loader />
          </div>
        ) : conversations.length > 0 ? (
          <div className="divide-y divide-gray-200">
            {conversations.map((conversation) => (
              <Link key={conversation._id} to={`${basePath}/${conversation._id}`}>
                <div className={`p-4 hover:bg-gray-50 transition-colors ${id === conversation._id ? "bg-gray-50" : ""}`}>
                  <div className="flex items-center gap-3">
                    <div className="h-10 w-10 rounded-full bg-gray-200 flex items-center justify-center text-gray-700 font-medium text-sm shrink-0">
                      {conversation.participants?.[1].user_name?.[0] || "?"}
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="font-medium text-gray-900 truncate">{conversation.participants?.[1].user_name || "Unknown"}</div>
                      {conversation.lastMessage && <div className="text-sm text-gray-500 truncate mt-1">{conversation.lastMessage.content}</div>}
                    </div>
                    {conversation.lastMessage && (
                      <div className="text-xs text-gray-400 shrink-0">
                        {new Date(conversation.lastMessage.timestamp).toLocaleTimeString(i18n.language || "en", {
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </div>
                    )}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center h-full text-gray-500 p-6">
            <FiMessageSquare className="w-12 h-12 mb-4 text-gray-400" />
            <p className="text-sm">{t("no_conversations")}</p>
          </div>
        )}
      </div>

      {/* <ContactSelectionModal
        isOpen={isModalOpen}
        onClose={async () => {
          await fetchConversations();
          setIsModalOpen(false);
        }}
      /> */}
    </div>
  );
};

export default ChatList;
